import { detectEnvironment } from '@/utils/detectEnvironment';

export const getInternalBasePath = (): string =>
  detectEnvironment() === 'staging' ? '/staging/' : '/';

export const getStagingSuffix = (value: string): string =>
  detectEnvironment() === 'staging' ? `${value}_staging` : value;
